export class Env {
    public apiUrl: string = /olivier\-rousseau\-guyot\.com/.test(window.location.href)
        ? 'https://us-central1-olivier-rousseau-guyot.cloudfunctions.net/api/'
        : 'http://localhost:5001/olivier-rousseau-guyot/us-central1/api/'

    isProd(url = window.location.href) {
        return /olivier\-rousseau\-guyot\.com/.test(url);
    }
}
